
import { Component, Vue } from 'vue-property-decorator';

import { namespace } from "vuex-class";
import "@/store/modules/forms/form7";
const form7State = namespace("Form7");

import Form7ProcessHeader from "@/components/process/Form7/components/Form7ProcessHeader.vue";
import Spinner from "@/components/utils/Spinner.vue";
import { form7DataInfoType, form7StatusInfoType } from '@/types/Information/Form7';
import { packageInfoType } from '@/types/Information';

@Component({
    components:{
        Form7ProcessHeader,
        Spinner
    }
})
export default class SubmitForm7 extends Vue {

    @form7State.State
    public currentNoticeOfUrgentApplicationId: string;

    @form7State.State
    public form7Info: form7DataInfoType;

    stepsCompleted = {} as form7StatusInfoType;  
    mountedData = false; 
    packageInfo = {} as packageInfoType;
    submitting = false;
    errorMsg=""

    mounted() {
        this.mountedData = false;    
        this.submitting = false;    
        this.errorMsg = ""
        this.stepsCompleted = {
            first: true,
            second: true,
            third: false
        }
        this.mountedData = true;         
    }  

    public submit() {

        this.submitting = true;
        this.errorMsg =""

        const url = "/form7/efiling/"+this.currentNoticeOfUrgentApplicationId+"/submit/";

        const header = {
            responseType: "json",
            headers: {
                "Content-Type": "application/json",
            }
        }

      

        this.$http.post(url, header)
        .then(res => {                            
            // this.submitting = false;
            if(res.data?.message=="success" && res.data?.redirectUrl){
                const eFilingUrl = res.data?.redirectUrl
                location.replace(eFilingUrl);
            }else
                this.submitting = false;
        }, err => {
            console.log(err.response?.data?.message);
            const generalError = " Error in submission. Please refresh the page and try again."
            if(err.response?.data?.message)
                this.errorMsg = err.response.data.message
            else if(err.response?.data?.detail)
                this.errorMsg = err.response.data.detail+generalError
            else
                this.errorMsg = generalError
            this.submitting = false;
        });        
    }

    public cancel() {
        this.$router.push({name: "dashboard" }) 
    }
}
